var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"search",attrs:{"type":"text","placeholder":"suchen…"},domProps:{"value":_vm.searchString},on:{"input":_vm.updateSearchString}})}
var staticRenderFns = []

export { render, staticRenderFns }